import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useIdleTimer } from 'react-idle-timer'

import { useAuthContext } from '../auth/AuthProvider'
import useViewportHeight from '../hooks/useViewportHeight'
import NotLoggedLayout from '../ui/layout/NotLoggedLayout'
import MainLayout from '../ui/layout/main'
import Loader from '../ui/views/Loader'
import SessionExpirationModal from '../ui/modals/sessionExpiration'
import RootRouter from '../router'
import ErrorRawBoundary from '../context/errors/ErrorRawBoundary'

import AppAlerts from './AppAlerts'

export const INACTIVE_SESSION_COUNTDOWN = 1000 * 60 * 10
export const TIME_SHOWING_INACTIVE_SESSION_MODAL = 1000 * 30

const App = () => {
  const {
    logout,
    isLoggingOut,
    user: authUser,
    isLoggingIn,
    isLoggedIn,
  } = useAuthContext()

  const [isInactive, setIsInactive] = useState(false)

  // Used to reset the error boundary on route changes
  const { key } = useLocation()
  const resetKeys = useMemo(() => [key], [key])

  const { pause } = useIdleTimer({
    timeout: INACTIVE_SESSION_COUNTDOWN,
    onIdle: () => {
      setIsInactive(true)
    },
  })
  useEffect(() => {
    if (
      process.env.NODE_ENV === 'development' &&
      process.env.REACT_APP_DEV_DISABLE_IDLE_TIMER
    ) {
      console.info('DEVELOPMENT: automatic log out is disabled')
      pause()
    }
  })

  useEffect(() => {
    const script1 = document.createElement('script');
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-BM0Q431584';
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-BM0Q431584');
    `;
    document.body.appendChild(script2);
  }, []);

  useViewportHeight()

  return isLoggingIn ? (
    <NotLoggedLayout>
      <Loader />
    </NotLoggedLayout>
  ) : (
    <MainLayout
      userName={authUser.userName}
      email={authUser.email}
      onLogout={logout}
      isLoggingOut={isLoggingOut}
    >
      <AppAlerts />
      <ErrorRawBoundary resetKeys={resetKeys}>
        <SessionExpirationModal
          time={TIME_SHOWING_INACTIVE_SESSION_MODAL}
          onContinue={() => setIsInactive(false)}
          onCompleted={logout}
          isOpen={isLoggedIn && isInactive}
        />
        <RootRouter />
      </ErrorRawBoundary>
    </MainLayout>
  )
}

export default App
